import { render } from "./Notifications.vue?vue&type=template&id=b3dbd328&scoped=true"
import script from "./Notifications.vue?vue&type=script&lang=js"
export * from "./Notifications.vue?vue&type=script&lang=js"

import "./Notifications.vue?vue&type=style&index=0&id=b3dbd328&lang=scss"
import "./Notifications.vue?vue&type=style&index=1&id=b3dbd328&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3dbd328"]])

export default __exports__